<ul class="nav">
  <li></li>
  <li>
    <app-header-notify></app-header-notify>
  </li>

  <li>
    <app-header-fullscreen></app-header-fullscreen>
  </li>
  <li>
    <app-header-user></app-header-user>
  </li>
</ul>
